import { Globe } from 'lucide-react'
import { Organization } from "@/types"

interface Props {
    organization: Organization
}

export default function OrganizationDetails({ organization }: Props) {
    return (
        <div className="lg:col-span-2 bg-white shadow rounded-lg">
            <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-medium text-gray-900">Organization Details</h3>
            </div>
            <div className="p-6">
                <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <dt className="text-sm font-medium text-gray-500">Name</dt>
                        <dd className="mt-1 text-sm text-gray-900">{organization.name}</dd>
                    </div>
                    <div>
                        <dt className="text-sm font-medium text-gray-500">Slug</dt>
                        <dd className="mt-1 text-sm text-gray-900 font-mono bg-gray-50 px-2 py-1 rounded">
                            {organization.slug}
                        </dd>
                    </div>
                    {organization.website && (
                        <div>
                            <dt className="text-sm font-medium text-gray-500">Website</dt>
                            <dd className="mt-1 text-sm">
                                <a
                                    href={organization.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-indigo-600 hover:text-indigo-700 inline-flex items-center"
                                >
                                    <Globe className="w-3 h-3 mr-1"/>
                                    {organization.website}
                                </a>
                            </dd>
                        </div>
                    )}
                    <div>
                        <dt className="text-sm font-medium text-gray-500">Created</dt>
                        <dd className="mt-1 text-sm text-gray-900">{organization.created_at}</dd>
                    </div>
                    {organization.description && (
                        <div className="md:col-span-2">
                            <dt className="text-sm font-medium text-gray-500">Description</dt>
                            <dd className="mt-1 text-sm text-gray-900">{organization.description}</dd>
                        </div>
                    )}
                </dl>
            </div>
        </div>
    )
}